// extracted by mini-css-extract-plugin
export default {"report_class":"campaigns-page_report_class__CQXoC","pbiLoadingPlaceholder":"campaigns-page_pbiLoadingPlaceholder__LvL2j"};